import { Card } from "@/components/ui/card";
import { useState } from "react";
import FacilitiesTableView from "./table";
import FacilityUnavailabilityTableView from "../facility_unavailability/table";
import useDocumentTitle from "@/components/ui/common/document-title";

const Facilities = () => {
  useDocumentTitle("Facilities");
  const [view, setView] = useState<"list" | "unavailability">("list");
  
  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        {view === "list" ? (
          <FacilitiesTableView onShowUnavailability={() => setView("unavailability")} />
        ) : (
          <FacilityUnavailabilityTableView onBack={() => setView("list")} />
        )}
      </Card>
    </div>
  );
};

export default Facilities;
